import { useNavigate } from 'react-router';

import {
    CARD_PARTNER_ONBOARDING_APPLY,
    MARKETPLACE_PARTNER_ONBOARDING_APPLY,
} from '@perpay-web/constants/paths';
import { useMount } from '@perpay-web/hooks/useMount';

const PhoExistingUserNotification = ({ isMarketplace = false }) => {
    const navigate = useNavigate();

    useMount(() => {
        if (isMarketplace) {
            navigate(
                `${MARKETPLACE_PARTNER_ONBOARDING_APPLY}?existing_user=true`,
                {
                    replace: true,
                },
            );
        } else
            navigate(`${CARD_PARTNER_ONBOARDING_APPLY}?existing_user=true`, {
                replace: true,
            });
    });

    return null;
};

export default PhoExistingUserNotification;
